import React from 'react'
import './menu.css' 

function Menu() {
  return (
    <div id="menu" className="fas fa-bars">

    </div>

  )
}

export default Menu